import React from "react";
import "../assets/css/floating.css";
import whatsappIcon from "../assets/images/whatsappIcon.svg";

export const FloatingWhatsapp = (data) => {
  const numberIcon = data.data.whatsappNumberIcon;

  return (
    // Solo visible en desktop — Google Ads valida en desktop
    <div className="floating-whatsapp-button">
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        className="phoneIcon"
        style={{ filter: "none" }}
      />
      <div style={{ alignSelf: "center" }}>
        <span>WhatsApp </span><b>{numberIcon}</b>
      </div>
    </div>
  );
};
